import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import LazyImage from '../../../hocs/Lazy/LazyImage';
import LogoReplace from '../../../hocs/LogoReplace/LogoReplace';
import { imageSizeTranslation } from '../../../utils/image';
import { translate, prefix } from '../../../utils/locale';
import { cleanInternalLinks } from '../../../utils/string';
import { purifier } from '../../../utils/dom';
import s from './Text.scss';

const Text = ({ content, setup, columnWidth, selectionId }) => {
	let headerIcon = null;
	if (content.headerIcon) {
		headerIcon = <LazyImage {...imageSizeTranslation(columnWidth, content.headerIcon)} className={[s.text_icon]} alt={content.headerIcon.alt} />;
	}

	let body = content.body && translate(setup, content.body);
	if (body && selectionId) body = body.replace('%order_id', selectionId);

	const color = content?.headerStyle?.color || '#000000';
	const HeaderTag = content?.headerDetails?.type || 'h2';
	const headerText = content.headerText && (
		<HeaderTag className={[s.text_headline, `u_fontSize__${content.headerDetails.size}`].join(' ')} style={{ textAlign: content.headerDetails.align.horizontal, color }}>
			<LogoReplace str={translate(setup, content.headerText)} />
		</HeaderTag>
	);
	const bodyText = body ? <div className={[s.text_body, (content.bodyDetails.subtitle ? s.text_body__subtitle : null), `u_fontSize__${content.bodyDetails.size}`].join(' ')} style={{ textAlign: content.bodyDetails.align.horizontal, color }} dangerouslySetInnerHTML={{ __html: purifier(body) }} /> : null;
	const linkText = content.link ? translate(setup, content.link, 'title') : '';
	const link = content.link && linkText ? <Link className={s.text_link} to={prefix(setup, cleanInternalLinks(translate(setup, content.link, 'url')))}>{ linkText }</Link> : null;
	const wrapperAttrs = {};
	let WrapperEl = 'div';
	if (content.link && !linkText) {
		WrapperEl = Link;
		wrapperAttrs.to = prefix(setup, translate(setup, content.link, 'url'));
	}

	return (
		<WrapperEl className={s.text} {...wrapperAttrs}>
			{ headerIcon }
			{ headerText }
			{ bodyText }
			{ link }
		</WrapperEl>
	);
};

const mapState = ({ checkout }, { ...props }) => ({
	...props,
	selectionId: checkout?.selection?.token,
});

export default hot(module)(connect(mapState)(Text));
